import { clientConfig } from "@/lib/config/client-config";
import { useConsentStore } from "@/store/consentStore";
import TelegramAnalytics from "@telegram-apps/analytics";

/**
 * Telegram's analytics SDK, started on consent like every other non-essential
 * tag. It lives here rather than in `startAnalytics` because it only means
 * anything inside a Mini App, and it must run after the Telegram SDK's own init.
 */

let started = false;
let armed = false;

function start(): void {
  if (started) return;
  started = true;

  TelegramAnalytics.init({
    token: clientConfig.telegramAnalyticsToken,
    appName: clientConfig.telegramAnalyticsIdentifier,
  });
}

/** Starts now if analytics are already allowed, otherwise on the first grant. */
export function startTelegramAnalyticsOnConsent(): void {
  const { status, analytics } = useConsentStore.getState();
  if (status === "decided" && analytics) {
    start();
    return;
  }

  if (armed) return;
  armed = true;

  const unsubscribe = useConsentStore.subscribe((state) => {
    if (state.status !== "decided" || !state.analytics) return;
    unsubscribe();
    start();
  });
}
